import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import Link from '#web-components/components/Link';
import Typography from '#web-components/components/Typography';
import styles from './LogoLink.styles';

const useStyles = makeStyles(styles, { name: 'EGovNavbar' });

export interface LogoLinkProps {
  appTitle: string;
  navLinkComponent: React.ElementType;
  homePath: string;
  logoIcon: React.ReactNode;
  direction?: 'right' | 'left';
}

const LogoLink: React.FC<LogoLinkProps> = (props) => {
  const {
    direction = 'left', appTitle, navLinkComponent, homePath, logoIcon,
  } = props;
  const classes = useStyles();

  return (
    <Link to={homePath} component={navLinkComponent}>
      <Grid
        container
        alignItems="center"
      >
        {
          direction === 'left' && <div className={classes.logo}>{logoIcon}</div>
        }
        <Grid item className={classes.appTitle}>
          <Typography variant="accentSmallCompact">{appTitle}</Typography>
        </Grid>
        {
          direction === 'right' && <div className={classes.logo}>{logoIcon}</div>
        }
      </Grid>
    </Link>
  );
};

export default LogoLink;
